import { styleLog } from "./../../../../utils/style-log";
import { Choice } from "./../../../../../../scripts/gen-question/src/declare/question.model";
import Vue from "vue";
import Component from "vue-class-component";
import { Model, Prop, Watch } from "vue-property-decorator";

@Component
export default class QuestionChoiceMixin extends Vue {
  public errorTextDict?: Record<string, string>;

  @Prop({ type: Object, default: () => ({}) })
  readonly conf!: Choice;

  @Prop({ type: Boolean, default: () => false })
  readonly checked!: boolean;

  @Prop({ default: () => {} })
  readonly answerCache!: any;

  @Prop({ default: () => {} })
  readonly current!: any;

  @Prop({ default: () => {}})
  readonly pause!: boolean;

  @Model("change", {}) readonly value!: any;

  mounted() {
    this.$nextTick(() => this.$emit("ready"));
  }

  @Watch("errorTextDict", { immediate: true, deep: true })
  onErrorTextChange(dict: Record<string, string>) {
    if (this.pause) return;
    let error: boolean;
    if (!dict) error = false;
    else error = Object.keys(dict).some((key) => !!dict[key]);
    console.log(dict);
    styleLog[error ? "dangerPrefix" : "successPrefix"]("触发错误检测");
    this.$emit("error", error);
  }
}
